<template>
  <div class="row sign-up-presentation">
    <div class="col-lg-6 left-screen px-4 pt-0">
      <div class="process-item" v-for="i, key in process" :key="key">
        <div class="row px-5">
          <div class="col-4">
            <h1 class="order-number">
              {{ key + 1 }}.
            </h1>
          </div>
          <div class="col-8 process-content">
            <span class="ml-3">
              <i :class="i.icon"></i>
            </span>
            <h2 class="text-poppins">
              {{ i.title }}
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-5 px-5 pl-lg-1">
      <div class="row d-md-flex justify-content-center mt-2">
        <div class="col-12 col-lg-8">
          <div class="page-header">
            <h2 class="text-bold text-poppins mb-0">CREATE ACCOUNT</h2>
            <p class="text-secondary">Please fill the form below or Sign in</p>
            <div>
              <transition name="fade">
                <div v-if="xhrError" class="alert alert-warning">
                  {{ xhrError }}
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <div class="row form d-flex justify-content-center">
        <div class="col-12 col-lg-8">
          <div class="input-group" :class="{
            focused: focusedField === 'name'
          }">
            <span class="input-group-addon d-flex align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-person"
                viewBox="0 0 16 16">
                <path
                  d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />
              </svg>
            </span>
            <input @focus="focusedField = 'name'" @blur="focusedField = ''" v-validate="'required'" name="name"
              type="text" id="name" v-model="name" class="form-control" :class="{
                hasValue: name && name.length > 0
              }">
            <label for="name">Full name</label>
          </div>
          <div class="inline-err">
            <span class="text-danger text-left" v-show="errors.has('name')">{{ errors.first('name') }}</span>
          </div>

          <div class="input-group" :class="{
            focused: focusedField === 'username'
          }">
            <span class="input-group-addon d-flex align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-envelope-at"
                viewBox="0 0 16 16">
                <path
                  d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z" />
                <path
                  d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648Zm-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z" />
              </svg>
            </span>
            <input @focus="focusedField = 'username'" @blur="focusedField = ''" v-validate="'required|email'"
              name="username" type="email" id="username" v-model="username" class="form-control" :class="{
                hasValue: username && username.length > 0
              }">
            <label for="email">Email</label>
          </div>
          <div class="inline-err">
            <span class="text-danger text-left" v-show="errors.has('username')">{{ errors.first('username') }}</span>
          </div>
          <div class="input-group" :class="{
            focused: focusedField === 'password'
          }">
            <span class="input-group-addon d-flex align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-lock"
                viewBox="0 0 16 16">
                <path
                  d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />
              </svg>
            </span>
            <input @focus="focusedField = 'password'" @blur="focusedField = ''" v-validate="'required'" type="password"
              name="password" id="password" v-model="password" class="form-control" :class="{
                hasValue: password && password.length > 0
              }" ref="password">
            <label for="password">Password</label>
          </div>

          <div class="inline-err">
            <span class="text-danger text-left" v-show="errors.has('password')">{{ errors.first('password') }}</span>
          </div>

          <div class="input-group" :class="{
            focused: focusedField === 'confirmPassword'
          }">
            <span class="input-group-addon d-flex align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-lock"
                viewBox="0 0 16 16">
                <path
                  d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />
              </svg>
            </span>
            <input @focus="focusedField = 'confirmPassword'" @blur="focusedField = ''"
              v-validate="'required|confirmed:password'" type="password" name="confirmPassword" id="confirmPassword"
              v-model="confirmPassword" class="form-control" :class="{
                hasValue: confirmPassword && confirmPassword.length > 0
              }">
            <label for="confirmPassword">Confirm password</label>
          </div>
          <div class="inline-err">
            <span class="text-danger text-left" v-show="errors.has('confirmPassword')">{{ errors.first('confirmPassword')
            }}</span>
          </div>

          <div class="w-100 mt-2">
            <button class="btn btn-info w-100" type="submit" @click="handleSubmit">
              <div v-if="loadingSubmit" class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>

              <span v-else>
                <span>SIGN UP</span>
              </span>
            </button>
          </div>
        </div>

      </div>
      <div class="row mt-4 d-flex justify-content-center">
        <div class="col-12 col-lg-8 d-flex justify-content-center">
          Already have an account&nbsp;-&nbsp;<router-link :to="{ name: 'login' }" class="sign-in mr-3">Sign
            In</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import APIService from "@/services/APIService.js";

export default {
  created() {
    this.xhrError = null;
  },
  data() {
    return {
      username: this.$route.query.username || "",
      password: "",
      name: "",
      confirmPassword: "",
      orderNumber: this.$route.query.ordernum || "",
      xhrError: null,
      loadingSubmit: false,
      focusedField: '',
      process: [
        {
          title: 'Upload',
          icon: 'bi bi-cloud-arrow-up'
        },
        {
          title: 'GetMXD',
          icon: 'bi bi-soundwave'
        },
        {
          title: 'Send Feedback',
          icon: 'bi bi-chat-square-text'
        },
        {
          title: 'Approve',
          icon: 'bi bi-check-circle'
        }
      ]
    };
  },
  computed: {
    orderSet() {
      if (
        this.$route.query.username &&
        this.$route.query.username != "" &&
        this.$route.query.ordernum &&
        this.$route.query.ordernum != ""
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    async handleSubmit() {

      this.xhrError = null;
      this.$validator.validateAll().then(async (result, err) => {
        console.log(err);
        // Submit form when no form errors
        if (result) {
          this.loadingSubmit = true
          const {
            name, username, password, orderNumber
          } = this;

          try {
            const { data, status } = await APIService.postCreateAccount(name, username, password, orderNumber)

            if (status === 200) {
              this.$store
                .dispatch("apiEvents/createAccount", {
                  username: data.user.username,
                  jwt: data.token,
                  userId: data.user.id,
                })
                .then(() => {
                  console.log(localStorage.getItem("jwt") != "");
                  if (localStorage.getItem("jwt") != "") {
                    if (this.$route.params.nextUrl != null) {
                      this.$router.push(this.$route.params.nextUrl);
                    } else {
                      this.$router.push("dashboard");
                    }
                  }
                }).finally(() => {
                  this.loadingSubmit = false
                })
            }
          } catch (error) {
            if (error.response && error.response.data) {
              this.xhrError = error.response.data.message || "Unexpected error occured. Contact support@getmxd.com"
            } else {
              this.xhrError = "Unexpected error occured. Contact support@getmxd.com"
            }
          } finally {
            this.loadingSubmit = false

          }
        }
      }).catch(err => {
        console.log(err);
      })
    },
  },
};
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@600&display=swap');

.left-screen {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  .process-item {
    // padding: 2rem;
    color: #2bfed1;

    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .col-4 {
        text-align: end;
      }
    }

    .order-number {
      font-size: 32px;
      font-weight: bold;
    }

    .process-content {
      display: flex;
      align-items: center;

      h2 {
        font-weight: bold;
        text-transform: uppercase;
        font-size: 38px;
      }

      span i {
        margin-right: 1rem;
        font-size: 36px
      }

    }
  }
}



.text-poppins {
  font-family: 'Poppins', sans-serif !important;
}

.page-header {
  h2 {
    font-size: 32px;
    font-weight: bold;
    letter-spacing: 1px;
  }

  p {
    font-size: 15px;
    font-weight: bold;
  }
}

.sign-in {
  color: #fff
}

.form-control {
  border: none;
  outline: none;
  color: #fff;
  background: none;
}

.form-control:focus {
  color: #fff;
}

.sign-up-presentation {
  max-width: 100vw;

  .col-lg-6 {
    background-color: black;
    height: 70vh;
  }

  .col-lg-5 {
    background-color: transparent;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }

  @media (max-width: 978px) {
    .left-screen {
      display: none;
    }
  }
}




.form {
  font-family: 'Poppins', sans-serif !important;

  .inline-err {
    margin-top: 0.5rem;
    display: flex;
    justify-content: flex-end;

    .text-danger {
      font-size: 0.9rem;
      justify-self: end;
    }
  }

  button {
    padding: 1rem;
    border-radius: 3rem;
    font-weight: 700;
    font-family: 'Poppins', sans-serif !important;
    background-color: #2bfed1;
    color: rgb(23, 23, 46);
  }

  .focused {
    background-color: #2bfed0b8;
    transition: all 0.4s;
    padding-left: 5px;
  }

  .input-group {
    position: relative;
    padding-top: 15px;
    padding-right: 15px;
    padding-bottom: 10px;
    margin-bottom: 0;
    border-radius: 10px;

    /* If there's only 1 input make it full height */
    &:first-child:last-child {
      height: 100%;

      .form-control {
        height: 100%;
      }
    }

    textarea {
      resize: none;
    }

    .input-highlight {
      content: "";
      width: 0;
      height: 2px;
      background: gray;
      position: absolute;
      display: block;
      bottom: 0;
      transition: width 0.4s ease;
    }

    label {
      position: absolute;
      left: 45px;
      top: 25px;
      transition: all 0.4s ease;
      color: gray;
    }

    .form-control {
      border-radius: 0;
      border-width: 0 0 2px 0;
      background: none !important;
      font-size: 14px;
      // border-bottom: 0.5px solid #383838;

      &:focus,
      &.hasValue {
        box-shadow: none;
        border-color: #6e6e6e; // Otherwise the border turns blue

        ~.input-highlight {
          width: 100%;
        }

        ~label {
          transform: scale(0.7);
          top: 0;
          left: 35px;
          color: white
        }
      }
    }
  }
}
</style>
